module.exports = __webpack_public_path__ + "img/wz-5-9.1c6b54c6.png";